<template>
  <a v-if="conversation.id != null" class="d-flex flex-column">
    <div class="d-flex flex-row flex-1">
      <div class="chat-user-img away align-self-top me-3 ms-0">
        <el-avatar :src="getAvatar(conversation)"
                   class="rounded-circle avatar-xs" alt="" />
        <div class="unread-message" v-if="conversation.unreadCount > 0">
                              <span class="badge badge-soft-danger rounded-pill">
                                {{ conversation.unreadCount }}
                              </span>
        </div>
      </div>
      <div class="flex-1 overflow-hidden">
        <div class="d-flex">
          <div
            v-bind:class="conversation.unreadCount > 0 ? 'fw-bold font-size-14 flex-1' : 'font-size-14 flex-1'"
            style="line-height: 20px"
          >
            {{ conversation.swName && conversation.swName.length > 0 ? conversation.swName : conversation.toName
            }}
          </div>

          <div class="font-size-11  chat-user-message" style="line-height: 20px" v-if="!hasConversationDraft()">
            {{ lastMessageTime(conversation.lastMessageTime * 1000000) }}
          </div>
          <div style="color: #d91b1b" class="font-size-11" v-else>
            Chưa gửi
          </div>
          <div class="mx-1" v-if="!conversation.isPin" />
          <div v-if="conversation.isPin" class="icon-star-fill text-warning font-size-14 mt-1 mx-1"></div>

          <el-tooltip class="item" effect="dark"
                      :content="getName(conversation.accountId)" placement="top">
            <div>
              <el-avatar :size="20"
                         :src="getAccountAvatar(conversation.accountId)"></el-avatar>
            </div>
          </el-tooltip>
        </div>
        <div class="chat-user-message text-normal mb-1 d-flex text-2-line">
                                <span v-if="conversation.typing" class="text-primary text-2-line fw-semibold"
                                      :content="conversation.lastMessageContent">
                                   {{ conversation.lastMessageContent }}
                                </span>
          <span v-else>
            <span class="text-2-line fw-semibold c-blue" v-if="hasConversationDraft()">
              {{ getDraftConversation() }}</span>
              <span class="text-2-line" v-else>
                                  {{ (conversation.group ? (conversation.dname && conversation.dname.length > 0 ? conversation.dname + ": " : "Bạn: ") : "") + lastConversationType(conversation.lastContent, conversation.lastMessageContent, conversation.lastMessageType)
                }}
                                </span>
          </span>


        </div>
      </div>
    </div>
    <div class="d-flex flex-row flex-1 justify-content-end" style="flex-wrap: wrap"
         v-if="conversation.tags">
      <div
        v-for="item in conversation.tags"
        :key="item.id">
        <Tag v-if="showTag(item.id)" :item="item" :selected="true" :isButton="true" />
      </div>
    </div>
    <div class="divider"></div>
  </a>
</template>

<script>
import Tag from "@/components/common/TagCustom";
import dateUtil from "@/lib/date-util";

export default {
  name: "ConversationItem",
  components: { Tag },
  props: ["conversation", "accounts"],
  methods: {

    getAccountAvatar(accountId) {
      let filter = this.accounts.filter(a => a.accountId == accountId);
      if (filter && filter.length > 0) {
        return filter[0].avatar;
      }
      return "";
      // return this.accounts.find(a => a.accountId == accountId).avatar;
    },
    getName(accountId) {

      let filter = this.accounts.filter(a => a.accountId == accountId);
      if (filter && filter.length > 0) {
        return this.getAccountName(filter[0]);
      }
      return "";
    },
    showTag(id) {
      let filter = this.app.tags.filter(t => t.id == id);
      if (filter && filter.length > 0) return true;
      return false;
    },
    getAvatar(conversation) {
      if (conversation.avatar) {
        return conversation.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },
    lastMessageTime(time) {
      return dateUtil.timestampToDate(time);
    },
    hasConversationDraft() {
      return this.app.draftMessageList[this.conversation.id];
    },
    getDraftConversation() {
      return this.app.draftMessageList[this.conversation.id].content;
    },
  },
};
</script>

<style scoped>

</style>